import { DEFAULT_STATE } from '@/modules/b2b/constants';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const state = {
  ...DEFAULT_STATE,
  notificationsLists: {
    data: []
  },
  notificationsBadges: {},
  totalCount: 0,
  params: {
    isIncludeTotalCount: true,
    limit: 20,
    offset: 0
  },
  quotationDetailData: null,
  quotationsPending: null,
  quotationsApproved: null,
  quotationsRejected: null,
  numberBadge: null
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
